<template>
  <!-- footer -->
  <div class="footer">
    <div class="logo"></div>
    <div class="opera">
      <el-row>
        <el-col :lg="12" :md="24" :sm="24" :xs="24">
          <div class="account">
            <div class="form flex-inline">
              <input type="text" class="input-signup" v-model="email" placeholder="Subscribe to our newsletter...">
              <div class="btn-signup" @click="subscribe">Sign Up</div>
            </div>
            <div class="links hidden-md-and-down">
              <el-link href="https://t.me/sharder_talk" :underline="false" target="_blank" class="link"><i class="ri-telegram-fill icon-link"></i></el-link>
              <el-link href="https://twitter.com/SharderChain" :underline="false" target="_blank" class="link"><i class="ri-twitter-fill icon-link"></i></el-link>
              <el-link href="https://github.com/Sharders" :underline="false" target="_blank" class="link"><i class="ri-github-fill icon-link"></i></el-link>
              <el-link href="https://medium.com/@SharderChain" :underline="false" target="_blank" class="link"><i class="ri-medium-fill icon-link"></i></el-link>
              <el-tooltip class="item" effect="dark" content="hi@sharder.org" placement="top-start">
                <el-link href="mailto:hi@sharder.org" :underline="false" class="link"><i class="ri-mail-open-fill icon-link"></i></el-link>
              </el-tooltip>
            </div>
          </div>
        </el-col>
        <el-col :lg="{span: 8, offset: 4}" class="hidden-md-and-down">
          <div class="anchors">
            <div class="anchor" @click="whitePaperDialog=true">{{ $t('navWhitePaper') }}</div>
            <div class="anchor" @click="goPage('/roadMap')">{{ $t('navRoadmap') }}</div>
<!--            <div class="anchor" @click="goPage('/team')">{{ $t('team') }}</div>-->
            <el-link class="anchor inline-block text-left" :underline="false" href="http://network.sharder.org:7215" target="_blank">{{ $t('navNetwork') }}</el-link>
            <!--<div class="anchor" @click="goPage('/auth')">{{ $t('hubValid') }}</div>-->
          </div>
        </el-col>

        <el-col :md="24" :sm="24" :xs="24" class="hidden-lg-and-up mobile-links">
          <div class="links">
            <el-link href="https://t.me/sharder_talk" :underline="false" target="_blank" class="link"><i class="ri-telegram-fill icon-link"></i></el-link>
            <el-link href="https://twitter.com/SharderChain" :underline="false" target="_blank" class="link"><i class="ri-twitter-fill icon-link"></i></el-link>
            <el-link href="https://github.com/Sharders" :underline="false" target="_blank" class="link"><i class="ri-github-fill icon-link"></i></el-link>
            <el-link href="https://medium.com/@SharderChain" :underline="false" target="_blank" class="link"><i class="ri-medium-fill icon-link"></i></el-link>
            <el-link href="mailto:hi@sharder.org" :underline="false" class="link"><i class="ri-mail-open-fill icon-link"></i></el-link>
          </div>
          <div class="anchors">
            <div class="anchor" @click="whitePaperDialog=true">{{ $t('navWhitePaper') }}</div>
            <div class="anchor" @click="goPage('/roadMap')">{{ $t('navRoadmap') }}</div>
            <!--<div class="anchor" @click="goPage('/team')">{{ $t('team') }}</div>-->
            <div class="anchor">{{ $t('navNetwork') }}</div>
            <!--<div class="anchor" @click="goPage('/auth')">{{ $t('hubValid') }}</div>-->
          </div>
        </el-col>
      </el-row>
    </div>

    <WhitePaper @closedWhitePaperDialog="whitePaperDialog=false" :show-dialog="whitePaperDialog"></WhitePaper>
  </div>
</template>

<script>
  import WhitePaper from './WhitePaperDialog.vue'
  import { isEmail } from '../../utils/validator'

  export default {
    name: 'my-footer',
    components: { WhitePaper },
    data () {
      return {
        whitePaperDialog: false,
        email: ''
      }
    },
    methods: {
      goPage (path) {
        const current = this.$router.currentRoute
        if (current.path === path) {
          return
        }
        this.$router.push({ path: path })
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      },
      subscribe () {
        // this.$notify.info({
        //   title: 'message',
        //   message: 'Will be open soon!'
        // })

        if (!isEmail(this.email)) {
          this.$message.error('Please enter your vaild email!')
          return
        }
        window.open('https://sharder.us19.list-manage.com/subscribe?u=42486ef928d63bf35eab30ab8&id=e6277ccbbd&MERGE0=' + this.email)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/common.scss';

  .inline-block {
    display: inline-block;
  }
  /* footer */
  .footer {
    padding: 7rem 14rem 8.4rem;
    background-color: #F5F5F5;

    .logo {
      width: 22.2rem;
      height: 5rem;
      background: url("../../../static/logo-black.png") center no-repeat;
      background-size: 22.2rem
    }

    .opera {
      margin-top: 7rem;

      .account {
        .input-signup {
          width: 60%;
          padding: 2.8rem 0 2.8rem 6rem;
          font-size: 2.3rem;
          background-color: #ffffff;
          outline: none;
          border: none;

          &::placeholder {
            color: #E6E6E6;
          }
        }
        .btn-signup {
          width: 30%;
          padding: 2.8rem 0;
          font-weight: bold;
          font-size: 2.3rem;
          text-align: center;
          color: #ffffff;
          background-color: #000000;
          cursor: pointer;
          transition: transform .3s ease;

          &:hover {
            transform: scale(1.05, 1.05);
            box-shadow: 0 0 10px rgba(0, 0, 0, .16);
          }
        }

        .links {
          display: flex;
          .link {
            width: 3.48rem;
            height: 3.48rem;
            margin-top: 10rem;
            cursor: pointer;
            background-size: contain;

            &:not(:first-child) {
              margin-left: 5rem;
            }
          }

          .icon-link {
            line-height: 3.48rem;
            font-size: 3.48rem;
          }
        }
      }

      .anchors {
        display: flex;
        flex-direction: column;
        text-align: left;

        .anchor {
          padding-left: 2rem;
          font-size: 2.1rem;
          font-weight: bold;
          color: #000000;
          cursor: pointer;
          transition: color .2s ease;
          position: relative;

          &::before {
            content: '';
            width: 0.8rem;
            height: 0.8rem;
            position: absolute;
            left: 0;
            bottom: 0.8rem;
            background-color: #000000;
            border-radius: 1rem;
          }

          &:hover {
            color: $color;
          }

          &:not(:first-child) {
            margin-top: 2.4rem;
          }
        }
      }
    }

    .mobile-links {
      margin-top: 4rem;
      align-items: flex-end;

      .anchors {
        .anchor {
          padding-left: 2rem;
          font-size: 1.6rem;
          position: relative;

          &::before {
            content: '';
            width: 0.8rem;
            height: 0.8rem;
            position: absolute;
            left: 0;
            bottom: 0.5rem;
            background-color: #000000;
            border-radius: 1rem;
          }
        }

        .anchor:not(:first-child) {
          margin-top: 1.6rem;
        }
      }

      .links {
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4rem;

        .icon-link {
          line-height: 4.8rem;
          font-size: 3.6rem;
        }
      }
    }
  }

  .links {
    .talk {
      background: url("../../../static/talk.png") center no-repeat;
    }
    .twitter {
      background: url("../../../static/twitter.png") center no-repeat;
    }
    .github {
      background: url("../../../static/github.png") center no-repeat;
    }
    .M {
      background: url("../../../static/m.png") center no-repeat;
    }
  }

  /* footer end */
</style>
<style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    .footer {
      padding: 3rem 1rem;

      .logo {
        max-width: 14rem;
        height: 3.14rem;
        margin: 0 auto;
        background-size: contain;
      }

      .opera {
        margin-top: 3rem;

        .account {
          .form {
            margin: 0 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;

            .btn-signup {
              width: calc(100% - 2rem);
              padding: 2.8rem 2rem;
              margin-top: 2rem;

              &:hover {
                transform: none;
              }
            }
            .input-signup {
              width: calc(100% - 2rem);
              padding: 2.8rem 2rem;
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .links {
    .el-link.el-link--default {
      color: #000000;
      transition: color .3s ease;
    }
    .el-link.el-link--default:hover {
      color: $color;
    }
  }
</style>
